<div class="flex flex-col text-center">
  <div class="flex justify-center my-6">
    <pd-app-title sizeClass="text-5xl"></pd-app-title>
  </div>

  <pd-install-pwa #pwaBtn [ngClass]="{ 'mb-4 block': pwaBtn.isVisible() }" />

  <div>
    <h2
      class="mb-6 py-6 bg-gradient-to-r from-accent-900 to-accent-400 text-3xl"
    >
      <img src="assets/misc/find-your-type.webp" alt="Find your type" class="img-find-your-type" />
    </h2>

    <div class="mb-4">
      <div>(It's free.)</div>
      <div class="accent-500">With our “5 traits” based personality matching,<br />
stop window-shopping for partners and find love.</div>
    </div>
  </div>

  <div class="flex mx-auto">
    <div class="flex flex-col">
      <!-- Social login -->
      <router-outlet />

      <button mat-raised-button color="primary" routerLink="acc/register">
        Sign up with email
      </button>
    </div>
  </div>

  <hr />

  <div class="mb-4">
    <button mat-raised-button color="primary" routerLink="acc/signin">
      Already have an account?
    </button>
  </div>

  <div class="text-xs">
    By continuing, you agree with our <a routerLink="tos">Terms</a> and <a routerLink="privacy-policy">Privacy Policy</a>.
  </div>
</div>
